
import { PropTypes } from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOurPeopleData } from '../../redux/slice/ourPeoplePage';
import { DecodeHtml } from '../../utils/decodeHtml';
import { retrunAssets } from '../../utils/getAssets';

const MeetOurLecturers = ({ data }) => {

    const name = data?.name
    const dispatch = useDispatch()
    useEffect(() => {
        if (data?.route?.path) {

            dispatch(fetchOurPeopleData(data?.route?.path))
        }
    }, [dispatch, data?.route?.path])
    const state = useSelector(state => state.ourPeople)
    const img = state?.data?.properties?.image !== null ? state?.data?.properties?.image[0]?.url : ""
    return (
        <div className="flex flex-col gap-3">
            <h1 className=" text-slate-900 text-lg font-semibold">Meet Our Lecturers</h1>
            <div className="w-full flex-col  sm:flex-row  h-fit bg-white rounded-2xl border-2 border-stone-300 p-6 py-8 flex items-center gap-3  "  >
                <div className="sm:w-32">
                    <div className="w-20 h-20 bg-neutral-500 rounded-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url('${retrunAssets(img)}')` }} />
                </div>
                <div className="text-center sm:text-left">
                    <h2 className=" text-slate-900 text-base font-semibold ">{name}</h2>
                    <p className='line-clamp-3'>
                        {
                            DecodeHtml({ html: state?.data?.properties?.description?.markup })
                        }
                    </p>
                </div>
            </div>
        </div>
    )
}
MeetOurLecturers.propTypes = {
    data: PropTypes.any
}
export default MeetOurLecturers